import { useContext } from 'react';
import { ProtocolContext } from './ProtocolContext';

export const useProtocol = () => {
  const context = useContext(ProtocolContext);

  if (!context) {
    throw new Error('useProtocol must be used within ProtocolProvider');
  }

  return context;
};
